import { render, staticRenderFns } from "./RequestAnAuthorisationCode.vue?vue&type=template&id=34e70190"
import script from "./RequestAnAuthorisationCode.vue?vue&type=script&lang=js"
export * from "./RequestAnAuthorisationCode.vue?vue&type=script&lang=js"
import style0 from "./RequestAnAuthorisationCode.vue?vue&type=style&index=0&id=34e70190&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports